<template>
	<div class="cash" ref="slideContainer">
		<Title :zhTitle="'现金获取能力'" :enTitle="'Cash Creation Ability'"></Title>
		<div class="cards">
			<div class="card" v-if="jyxxjl">
				<div v-if="language === 'zh'" class="zh">
					<div class="card-title">{{ jsonData.year }}{{ periodName }} <span class="card-text">经营性现金流</span></div>
					<div class="num">
						{{ jyxxjl }}<span class="unit">{{ jyxxjlUnit }}</span>
					</div>
				</div>
				<div v-else-if="language === 'en'" class="en">
					<div class="card-title">
						{{ jsonData.year }}{{ periodNameEng }}
						<div class="card-text">Operating Cash Flow</div>
					</div>
					<div class="num">
						{{ jyxxjl }}<span class="unit">{{ jyxxjlUnit }}</span>
					</div>
				</div>
				<div class="charts" ref="chart1"></div>
			</div>
			<div class="card" v-if="tzxxjl">
				<div v-if="language === 'zh'" class="zh">
					<div class="card-title">{{ jsonData.year }}{{ periodName }} <span class="card-text">投资性现金流</span></div>
					<div class="num">
						{{ tzxxjl }}<span class="unit">{{ tzxxjlUnit }}</span>
					</div>
				</div>
				<div v-else-if="language === 'en'" class="en">
					<div class="card-title">
						{{ jsonData.year }}{{ periodNameEng }}
						<div class="card-text">Investment Cash Flow</div>
					</div>
					<div class="num">
						{{ tzxxjl }}<span class="unit">{{ tzxxjlUnit }}</span>
					</div>
				</div>
				<div class="charts" ref="chart2"></div>
			</div>
			<div class="card" v-if="czxxjl">
				<div v-if="language === 'zh'" class="zh">
					<div class="card-title">{{ jsonData.year }}{{ periodName }} <span class="card-text">筹资性现金流</span></div>
					<div class="num">
						{{ czxxjl }}<span class="unit">{{ czxxjlUnit }}</span>
					</div>
				</div>
				<div v-else-if="language === 'en'" class="en">
					<div class="card-title">
						{{ jsonData.year }}{{ periodNameEng }}
						<div class="card-text">Financing Cash Flow</div>
					</div>
					<div class="num">
						{{ czxxjl }}<span class="unit">{{ czxxjlUnit }}</span>
					</div>
				</div>
				<div class="charts" ref="chart3"></div>
			</div>
		</div>
	</div>
</template>

<script>
import Title from '@/components/title.vue'
import { mapState } from 'vuex'
import * as echarts from 'echarts'

export default {
	name: 'cash',
	components: {
		Title,
	},
	props: {
		index: {
			type: Number,
		},
	},
	data() {
		return {
			lineOption: {
				//echarts图配置
				tooltip: {
					show: false,
				},
				legend: {
					show: false,
				},
				color: ['rgba(235,92,91,0.7)'],
				grid: {
          top: 40,
          left: 20,
          right: 20,
          bottom: 10,
					containLabel: true,
				},
				xAxis: {
					type: 'category',
					axisTick: {
						show: false,
					},
					axisLine: {
						lineStyle: {
							color: '#F0F0F0',
						},
					},
					axisLabel: {
						color: '#696969',
						fontSize: 12,
						interval: 0, // 显示所有类目
						showMinLabel: true, // 显示最小类目标签
						showMaxLabel: true, // 显示最大类目标签
						padding: [5, 10], // 增加内边距
					},
					data: [],
				},
				yAxis: [
					{
						type: 'value',
						show: false,
						axisLabel: {
							show: false, // 不显示轴标签
						},
					},
				],
				series: [
					// 第一个圆柱顶部的椭圆形
					{
						type: 'pictorialBar', //pictorialBar(象形柱图)
						symbolSize: [18, 6], //椭圆的大小[宽，高]
						symbolOffset: [0, -3], //图形偏移[x轴，y轴]，不确定的话，可以微调，本实例x轴叠加了柱状之间的间距[-7+(间距7/2),y轴]
						z: 12, //图形的层级，控制图形的前后顺序，z值小的图形会被z值大的图形覆盖
						symbolPosition: 'end', //椭圆位置，默认'start'，在最底下，end是最上面
						itemStyle: {
							color: '#F06160',
						},
						data: [],
					},
					{
						data: [],
						type: 'bar',
						barWidth: 18,
						label: {
							show: true,
							position: 'top',
						},
						itemStyle: {
							// 图形样式
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{
									offset: 0, // 0%处的颜色
									color: '#d32f2e',
								},
								{
									offset: 1, // 100%处的颜色
									color: '#FEAB66',
								},
							]),
						},
					},
					// 第一个圆柱底部的椭圆形
					{
						type: 'pictorialBar',
						symbolSize: [18, 6],
						symbolOffset: [0, 1],
						z: 12,
						itemStyle: {
							color: '#F06160',
						},
						data: [],
					},
				],
			},
			observer: null, // IntersectionObserver 对象
			line1Data: {
				xAxisData: [],
				seriesData: [],
			},
			line2Data: {
				xAxisData: [],
				seriesData: [],
			},
			line3Data: {
				xAxisData: [],
				seriesData: [],
			},
			pageData: {},
			jyxxjl: '', // 经营性现金流
			jyxxjlUnit: '', // 经营性现金流单位
			tzxxjl: '', // 投资性现金流
			tzxxjlUnit: '', // 投资性现金流单位
			czxxjl: '', // 筹资性现金流
			czxxjlUnit: '', // 筹资性现金流单位
			type: 'area', // 折线图类型
		}
	},
	computed: {
		...mapState(['theme', 'language', 'jsonData', 'periodName', 'periodNameEng','isLongChart']),
	},
  watch:{
    language(newVal, oldVal) { // 语言切换时重新渲染数据
      this.initData(); // 语言切换重新初始化数据
    }
  },
	mounted() {
		this.initData(); // 初始化数据
	},
	beforeDestroy() { // 组件销毁时销毁echarts实例
		const myChart1 = echarts.init(this.$refs.chart1)
		const myChart2 = echarts.init(this.$refs.chart2)
		const myChart3 = echarts.init(this.$refs.chart3)
		if (this.observer) {
			this.observer.disconnect()
		}
		if (myChart1) {
			myChart1.dispose()
		}
		if (myChart2) {
			myChart2.dispose()
		}
		if (myChart3) {
			myChart3.dispose()
		}
	},
	methods: {
    initData(){ // 初始化数据
      this.initObserver() // 初始化IntersectionObserver
      let data = JSON.parse(this.jsonData.moduleData) // 获取数据
      if (this.language == 'zh') { // 根据语言修改获取英文还是中文数据
        data = JSON.parse(this.jsonData.moduleData)
      } else {
        data = JSON.parse(this.jsonData.moduleDataEng)
      }
      this.pageData = data[this.index] // 获取当前页面数据

      this.type = data[this.index].graphId == 5 ? '3d' : data[this.index].graphId == 1 ? 'bar' : 'area' // 获取图形类型
      if (this.pageData.jyxxjlData.length > 0) { // 经营性现金流数据初始化
        // 判断当年是否有数据，没数据的话显示未披露字样
        if (this.pageData.jyxxjlData[this.pageData.jyxxjlData.length - 1].period.match(/\d+/) != this.jsonData.year || this.pageData.jyxxjlData[this.pageData.jyxxjlData.length - 1].value === '') {
          this.jyxxjl = this.language === 'zh' ? '未披露' : 'Undisclosed';
        } else {
          this.jyxxjl = this.pageData.jyxxjlData[this.pageData.jyxxjlData.length - 1].value
          this.jyxxjlUnit = this.pageData.jyxxjlData[this.pageData.jyxxjlData.length - 1].unit
        }

        this.line1Data.xAxisData=[]; // 清空x轴数据
        this.line1Data.seriesData=[]; // 清空y轴数据
        this.pageData.jyxxjlData.forEach(item => {
          if(item.realityValue!==''){ // 真是值有值的话设置x轴和y轴数据
            this.line1Data.xAxisData.push(item.period)
            this.line1Data.seriesData.push({
              value: item.realityValue.replace(/,/g, ''),
              label: item.value,
              unit: item.unit
            })
          }
        })
      }
      if (this.pageData.tzxxjlData.length > 0) {
        if (this.pageData.tzxxjlData[this.pageData.tzxxjlData.length - 1].period.match(/\d+/) != this.jsonData.year || this.pageData.tzxxjlData[this.pageData.tzxxjlData.length - 1].value === '') {
          this.tzxxjl = this.language === 'zh' ? '未披露' : 'Undisclosed';
        } else {
          this.tzxxjl = this.pageData.tzxxjlData[this.pageData.tzxxjlData.length - 1].value
          this.tzxxjlUnit = this.pageData.tzxxjlData[this.pageData.tzxxjlData.length - 1].unit
        }
        this.line2Data.xAxisData=[]; // 清空x轴数据
        this.line2Data.seriesData=[]; // 清空y轴数据
        this.pageData.tzxxjlData.forEach(item => {
          if(item.realityValue!==''){ // 真是值有值的话设置x轴和y轴数据
            this.line2Data.xAxisData.push(item.period)
            this.line2Data.seriesData.push({
              value: item.realityValue.replace(/,/g, ''),
              label: item.value,
              unit: item.unit
            })
          }
        })
      }
      if (this.pageData.czxxjlData.length > 0) {
        if (this.pageData.czxxjlData[this.pageData.czxxjlData.length - 1].period.match(/\d+/) != this.jsonData.year || this.pageData.czxxjlData[this.pageData.czxxjlData.length - 1].value === '') {
          this.czxxjl = this.language === 'zh' ? '未披露' : 'Undisclosed';
        } else {
          this.czxxjl = this.pageData.czxxjlData[this.pageData.czxxjlData.length - 1].value;
          this.czxxjlUnit = this.pageData.czxxjlData[this.pageData.czxxjlData.length - 1].unit
        }
        this.line3Data.xAxisData=[]; // 清空x轴数据
        this.line3Data.seriesData=[]; // 清空y轴数据
        this.pageData.czxxjlData.forEach(item => {
          if(item.realityValue!==''){ // 真是值有值的话设置x轴和y轴数据
            this.line3Data.xAxisData.push(item.period)
            this.line3Data.seriesData.push({
              value: item.realityValue.replace(/,/g, ''),
              label: item.value,
              unit: item.unit
            })
          }
        })
      }
    },
		initObserver() {
      if (this.isLongChart) { // 如果是长图就直接渲染图表
        setTimeout(() => {
          this.initChart();
        }, 200)
      } else { // 创建一个观察器实例并传入回调函数
        // 创建一个新的 IntersectionObserver 对象，当其监听到目标元素的可见部分（的比例）超过了一个或多个阈值（threshold）时，会执行指定的回调函数
        this.observer = new IntersectionObserver(
            entries => {
              entries.forEach(entry => {
                if (entry.isIntersecting) {
                  this.initChart()
                  this.observer.disconnect() // 一旦元素进入视窗，就断开观察器
                }
              })
            },
            {
              threshold: 0.1, // 当目标元素的可见比例达到10%时，触发回调
            }
        )
        this.observer.observe(this.$refs.slideContainer)
      }
		},
		initChart() {
			if (this.$refs.chart1) { // 初始化echarts实例
				const myChart1 = echarts.init(this.$refs.chart1) // 获取echarts实例
				const option1 = JSON.parse(JSON.stringify(this.lineOption))
				option1.xAxis.data = this.line1Data.xAxisData // 设置x轴数据
				option1.series[0].data = this.line1Data.seriesData // 设置y轴数据
				option1.series[1].label.formatter = params => { // 设置y轴label的格式
					if (this.language == 'zh') {
						return params.data.label + params.data.unit
					} else {
						return params.data.label + params.data.unit.substring(0, 1)
					}
				}

				if (this.type == '3d') { // 3d图表
					let topArr = []
					topArr = this.line1Data.seriesData.map(item => { // 设置顶部的label
						if (item.label < 0) {
							return {
								value: item.value,
								symbolOffset: [0, 3],
							}
						} else {
							return {
								value: item.value,
							}
						}
					})
					let bottomArr = []
					bottomArr = this.line1Data.seriesData.map(item => { // 设置底部的label
						if (item.value < 0) {
							return {
								value: item.value,
								symbolOffset: [0, -1],
							}
						} else {
							return {
								value: item.value,
							}
						}
					})
					option1.series[0].data = topArr // 设置顶部的label
					option1.series[1].data = this.line1Data.seriesData // 设置y轴数据
					option1.series[2].data = bottomArr // 设置底部的label
					option1.series[1].itemStyle.color = params => { // 设置顶部和底部的label颜色
						if (params.data.value < 0) { // 颜色渐变
							return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{
									offset: 1, // 0%处的颜色
									color: '#d32f2e',
								},
								{
									offset: 0, // 100%处的颜色
									color: '#FEAB66',
								},
							])
						} else {
							return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{
									offset: 0, // 0%处的颜色
									color: '#d32f2e',
								},
								{
									offset: 1, // 100%处的颜色
									color: '#FEAB66',
								},
							])
						}
					}
				} else if (this.type == 'bar') { // 柱状图
					option1.series[0].data = []
					option1.series[1].data = this.line1Data.seriesData // 设置y轴数据
					option1.series[1].itemStyle.borderRadius = 8 // 设置柱状图圆角
					option1.series[2].data = []
				} else if (this.type == 'area') { // 折线图
					option1.series[0].data = []
					option1.series[1].data = this.line1Data.seriesData // 设置y轴数据
					option1.series[1].type = 'line' // 设置折线图类型为折线
					option1.series[1].smooth = true // 设置折线图平滑
					option1.series[1].symbol = 'circle' // 设置折线图圆点为圆形
					option1.series[1].symbolSize = 6 // 设置折线图圆点大小
					option1.series[1].areaStyle = { // 设置折线图区域颜色
						color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
							{
								offset: 1,
								color: 'rgba(254,171,102,0)',
							},
							{
								offset: 0,
								color: 'rgba(235,92,91,0.7)',
							},
						]),
					}
					option1.series[2].data = []
				}
        if (this.theme == 'red') { // 红色
          option1.series[1].itemStyle.color = params => {
            if (params.data.value < 0) { // 颜色渐变
              return new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0, // 0%处的颜色
                  color: '#d32f2e',
                },
                {
                  offset: 1, // 100%处的颜色
                  color: '#FEAB66',
                },
              ])
            } else {
              return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0, // 0%处的颜色
                  color: '#d32f2e',
                },
                {
                  offset: 1, // 100%处的颜色
                  color: '#FEAB66',
                },
              ])
            }
          }
        } else if (this.theme == 'purple') { // 紫色
					option1.series[0].itemStyle.color = '#FFF1D0'
					option1.series[1].itemStyle.color = '#F9CD70'
					if (option1.series[1].areaStyle) { // 如果折线图存在设置折线图区域颜色
						option1.series[1].areaStyle = {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{
									offset: 1,
									color: 'rgba(249, 205, 112, 0)',
								},
								{
									offset: 0,
									color: 'rgba(249, 205, 112, 0.70)',
								},
							]),
						}
					}
					option1.series[1].label.color = '#2A234C' // 设置label字体颜色
					option1.series[1].label.fontSize = 12 // 设置label字体大小
					option1.series[1].label.fontWeight = 400 // 设置label字体粗细
					option1.series[2].itemStyle.color = '#EBB94F' // 设置顶部和底部的label颜色
				} else if (this.theme == 'blue') { // 蓝色
					option1.color = ['#4782EA']
					option1.series[0].itemStyle.color = '#92D5FF'
					option1.series[1].itemStyle.color = params => { // 设置顶部和底部的label颜色
						if (params.data.value < 0) { // 颜色渐变
							return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{
									offset: 1, // 0%处的颜色
									color: '#59B9F5',
								},
								{
									offset: 0, // 100%处的颜色
									color: '#D7F0FF',
								},
							])
						} else {
							return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{
									offset: 0, // 0%处的颜色
									color: '#59B9F5',
								},
								{
									offset: 1, // 100%处的颜色
									color: '#D7F0FF',
								},
							])
						}
					}
					if (option1.series[1].areaStyle) { // 如果折线图存在设置折线图区域颜色
						option1.series[1].areaStyle = {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{
									offset: 1,
									color: 'rgba(91, 186, 245, 0)',
								},
								{
									offset: 0,
									color: 'rgba(103, 191, 245, 1)',
								},
							]),
						}
					}
					option1.series[1].label.color = '#000000'
					option1.series[1].label.fontSize = 12
					option1.series[1].label.fontWeight = 400
					option1.series[2].itemStyle.color = '#C0E6FF'
				} else if (this.theme == 'yellow') { // 黄色
					option1.color = ['#F8BC27']
					option1.series[0].itemStyle.color = '#FFBE1E'
					option1.series[1].itemStyle.color = params => { // 设置顶部和底部的label颜色
						if (params.data.value < 0) { // 颜色渐变
							return new echarts.graphic.LinearGradient(0, 1, 0, 0, [
								{
									offset: 1, // 0%处的颜色
									color: 'rgba(248,188,39,0)',
								},
								{
									offset: 0, // 100%处的颜色
									color: 'rgba(248,188,39,0.7)',
								},
							])
						} else {
							return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{
									offset: 1,
									color: 'rgba(248,188,39,0)',
								},
								{
									offset: 0,
									color: 'rgba(248,188,39,0.7)',
								},
							])
						}
					}
					if (option1.series[1].areaStyle) { // 如果折线图存在设置折线图区域颜色
						option1.series[1].areaStyle = {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{
									offset: 1,
									color: 'rgba(248,188,39,0)',
								},
								{
									offset: 0,
									color: 'rgba(248,188,39,0.7)',
								},
							]),
						}
					}
					option1.series[1].label.color = '#000000' // 设置label字体颜色
					option1.series[1].label.fontSize = 12 // 设置label字体大小
					option1.series[1].label.fontWeight = 400 // 设置label字体粗细
					option1.series[2].itemStyle.color = '#DFA20A' // 设置顶部和底部的label颜色
				}
				myChart1.setOption(option1) // 设置option
			}
			if (this.$refs.chart2) {
				const myChart2 = echarts.init(this.$refs.chart2)
				const option2 = JSON.parse(JSON.stringify(this.lineOption))
				option2.xAxis.data = this.line2Data.xAxisData
				option2.series[0].data = this.line2Data.seriesData
				option2.series[1].label.formatter = params => {
					if (this.language == 'zh') {
						return params.data.label + params.data.unit
					} else {
						return params.data.label + params.data.unit.substring(0, 1)
					}
				}

				if (this.type == '3d') {
					let topArr = []
					topArr = this.line2Data.seriesData.map(item => {
						if (item.label < 0) {
							return {
								value: item.value,
								symbolOffset: [0, 3],
							}
						} else {
							return {
								value: item.value,
							}
						}
					})
					let bottomArr = []
					bottomArr = this.line2Data.seriesData.map(item => {
						if (item.value < 0) {
							return {
								value: item.value,
								symbolOffset: [0, -1],
							}
						} else {
							return {
								value: item.value,
							}
						}
					})
					option2.series[0].data = topArr
					option2.series[1].data = this.line2Data.seriesData
					option2.series[2].data = bottomArr
					option2.series[1].itemStyle.color = params => {
						if (params.data.value < 0) {
							return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{
									offset: 1, // 0%处的颜色
									color: '#d32f2e',
								},
								{
									offset: 0, // 100%处的颜色
									color: '#FEAB66',
								},
							])
						} else {
							return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{
									offset: 0, // 0%处的颜色
									color: '#d32f2e',
								},
								{
									offset: 1, // 100%处的颜色
									color: '#FEAB66',
								},
							])
						}
					}
				} else if (this.type == 'bar') {
					option2.series[0].data = []
					option2.series[1].data = this.line2Data.seriesData
					option2.series[1].itemStyle.borderRadius = 8
					option2.series[2].data = []
				} else if (this.type == 'area') {
					option2.series[0].data = []
					option2.series[1].data = this.line2Data.seriesData
					option2.series[1].type = 'line'
					option2.series[1].smooth = true
					option2.series[1].symbol = 'circle'
					option2.series[1].symbolSize = 6
					option2.series[1].areaStyle = {
						color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
							{
								offset: 1,
								color: 'rgba(254,171,102,0)',
							},
							{
								offset: 0,
								color: 'rgba(235,92,91,0.7)',
							},
						]),
					}
					option2.series[2].data = []
				}
        if (this.theme == 'red') {
          option2.series[1].itemStyle.color = params => {
            if (params.data.value < 0) {
              return new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0, // 0%处的颜色
                  color: '#d32f2e',
                },
                {
                  offset: 1, // 100%处的颜色
                  color: '#FEAB66',
                },
              ])
            } else {
              return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0, // 0%处的颜色
                  color: '#d32f2e',
                },
                {
                  offset: 1, // 100%处的颜色
                  color: '#FEAB66',
                },
              ])
            }
          }
        } else if (this.theme == 'purple') {
					option2.series[0].itemStyle.color = '#D9EFFF'
					option2.series[1].itemStyle.color = '#8BCAEA'
					if (option2.series[1].areaStyle) {
						option2.series[1].areaStyle = {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{
									offset: 1,
									color: 'rgba(139, 202, 234, 0)',
								},
								{
									offset: 0,
									color: 'rgba(139, 202, 234, 0.70)',
								},
							]),
						}
					}
					option2.series[1].label.color = '#2A234C'
					option2.series[1].label.fontSize = 12
					option2.series[1].label.fontWeight = 400
					option2.series[2].itemStyle.color = '#72BDE4'
				} else if (this.theme == 'blue') {
					option2.color = ['#4782EA']
					option2.series[0].itemStyle.color = '#92D5FF'
					option2.series[1].itemStyle.color = params => {
						if (params.data.value < 0) {
							return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{
									offset: 1, // 0%处的颜色
									color: '#59B9F5',
								},
								{
									offset: 0, // 100%处的颜色
									color: '#D7F0FF',
								},
							])
						} else {
							return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{
									offset: 0, // 0%处的颜色
									color: '#59B9F5',
								},
								{
									offset: 1, // 100%处的颜色
									color: '#D7F0FF',
								},
							])
						}
					}
					if (option2.series[1].areaStyle) {
						option2.series[1].areaStyle = {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{
									offset: 1,
									color: 'rgba(91, 186, 245, 0)',
								},
								{
									offset: 0,
									color: 'rgba(103, 191, 245, 1)',
								},
							]),
						}
					}
					option2.series[1].label.color = '#000000'
					option2.series[1].label.fontSize = 12
					option2.series[1].label.fontWeight = 400
					option2.series[2].itemStyle.color = '#C0E6FF'
				} else if (this.theme == 'yellow') {
					option2.color = ['#F8BC27']
					option2.series[0].itemStyle.color = '#FFBE1E'
					option2.series[1].itemStyle.color = params => {
						if (params.data.value < 0) {
							return new echarts.graphic.LinearGradient(0, 1, 0, 0, [
								{
									offset: 1, // 0%处的颜色
									color: 'rgba(248,188,39,0)',
								},
								{
									offset: 0, // 100%处的颜色
									color: 'rgba(248,188,39,0.7)',
								},
							])
						} else {
							return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{
									offset: 1,
									color: 'rgba(248,188,39,0)',
								},
								{
									offset: 0,
									color: 'rgba(248,188,39,0.7)',
								},
							])
						}
					}
					if (option2.series[1].areaStyle) {
						option2.series[1].areaStyle = {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{
									offset: 1,
									color: 'rgba(248,188,39,0)',
								},
								{
									offset: 0,
									color: 'rgba(248,188,39,0.7)',
								},
							]),
						}
					}
					option2.series[1].label.color = '#000000'
					option2.series[1].label.fontSize = 12
					option2.series[1].label.fontWeight = 400
					option2.series[2].itemStyle.color = '#DFA20A'
				}
				myChart2.setOption(option2)
			}
			if (this.$refs.chart3) {
				const myChart3 = echarts.init(this.$refs.chart3)
				const option3 = JSON.parse(JSON.stringify(this.lineOption))
				option3.xAxis.data = this.line3Data.xAxisData
				option3.series[1].label.formatter = params => {
					if (this.language == 'zh') {
						return params.data.label + params.data.unit
					} else {
						return params.data.label + params.data.unit.substring(0, 1)
					}
				}

				if (this.type == '3d') {
					let topArr = []
					topArr = this.line3Data.seriesData.map(item => {
						if (item.label < 0) {
							return {
								value: item.value,
								symbolOffset: [0, 3],
							}
						} else {
							return {
								value: item.value,
							}
						}
					})
					let bottomArr = []
					bottomArr = this.line3Data.seriesData.map(item => {
						if (item.value < 0) {
							return {
								value: item.value,
								symbolOffset: [0, -1],
							}
						} else {
							return {
								value: item.value,
							}
						}
					})
					option3.series[0].data = topArr
					option3.series[1].data = this.line3Data.seriesData
					option3.series[2].data = bottomArr
					option3.series[1].itemStyle.color = params => {
						if (params.data.value < 0) {
							return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{
									offset: 1, // 0%处的颜色
									color: '#d32f2e',
								},
								{
									offset: 0, // 100%处的颜色
									color: '#FEAB66',
								},
							])
						} else {
							return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{
									offset: 0, // 0%处的颜色
									color: '#d32f2e',
								},
								{
									offset: 1, // 100%处的颜色
									color: '#FEAB66',
								},
							])
						}
					}
				} else if (this.type == 'bar') {
					option3.series[0].data = []
					option3.series[1].data = this.line3Data.seriesData
					option3.series[1].itemStyle.borderRadius = 8
					option3.series[2].data = []
				} else if (this.type == 'area') {
					option3.series[0].data = []
					option3.series[1].data = this.line3Data.seriesData
					option3.series[1].type = 'line'
					option3.series[1].smooth = true
					option3.series[1].symbol = 'circle'
					option3.series[1].symbolSize = 6
					option3.series[1].areaStyle = {
						color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
							{
								offset: 1,
								color: 'rgba(254,171,102,0)',
							},
							{
								offset: 0,
								color: 'rgba(235,92,91,0.7)',
							},
						]),
					}
					option3.series[2].data = []
				}
        if (this.theme == 'red') {
          option3.series[1].itemStyle.color = params => {
            if (params.data.value < 0) {
              return new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0, // 0%处的颜色
                  color: '#d32f2e',
                },
                {
                  offset: 1, // 100%处的颜色
                  color: '#FEAB66',
                },
              ])
            } else {
              return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0, // 0%处的颜色
                  color: '#d32f2e',
                },
                {
                  offset: 1, // 100%处的颜色
                  color: '#FEAB66',
                },
              ])
            }
          }
        } else if (this.theme == 'purple') {
					option3.series[0].itemStyle.color = '#FFE2EA'
					option3.series[1].itemStyle.color = '#F3ADBF'

					if (option3.series[1].areaStyle) {
						option3.series[1].areaStyle = {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{
									offset: 1,
									color: 'rgba(243, 173, 191, 0)',
								},
								{
									offset: 0,
									color: 'rgba(243, 173, 191, 0.70)',
								},
							]),
						}
					}
					option3.series[1].label.color = '#2A234C'
					option3.series[1].label.fontSize = 12
					option3.series[1].label.fontWeight = 400
					option3.series[2].itemStyle.color = '#E887A0'
				} else if (this.theme == 'blue') {
					option3.color = ['#4782EA']
					option3.series[0].itemStyle.color = '#92D5FF'
					option3.series[1].itemStyle.color = params => {
						if (params.data.value < 0) {
							return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{
									offset: 1, // 0%处的颜色
									color: '#59B9F5',
								},
								{
									offset: 0, // 100%处的颜色
									color: '#D7F0FF',
								},
							])
						} else {
							return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{
									offset: 0, // 0%处的颜色
									color: '#59B9F5',
								},
								{
									offset: 1, // 100%处的颜色
									color: '#D7F0FF',
								},
							])
						}
					}
					if (option3.series[1].areaStyle) {
						option3.series[1].areaStyle = {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{
									offset: 1,
									color: 'rgba(91, 186, 245, 0)',
								},
								{
									offset: 0,
									color: 'rgba(103, 191, 245, 1)',
								},
							]),
						}
					}
					option3.series[1].label.color = '#000000'
					option3.series[1].label.fontSize = 12
					option3.series[1].label.fontWeight = 400
					option3.series[2].itemStyle.color = '#C0E6FF'
				} else if (this.theme == 'yellow') {
					option3.color = ['#F8BC27']
					option3.series[0].itemStyle.color = '#FFBE1E'
					option3.series[1].itemStyle.color = params => {
						if (params.data.value < 0) {
							return new echarts.graphic.LinearGradient(0, 1, 0, 0, [
								{
									offset: 1, // 0%处的颜色
									color: 'rgba(248,188,39,0)',
								},
								{
									offset: 0, // 100%处的颜色
									color: 'rgba(248,188,39,0.7)',
								},
							])
						} else {
							return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{
									offset: 1,
									color: 'rgba(248,188,39,0)',
								},
								{
									offset: 0,
									color: 'rgba(248,188,39,0.7)',
								},
							])
						}
					}
					if (option3.series[1].areaStyle) {
						option3.series[1].areaStyle = {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{
									offset: 1,
									color: 'rgba(248,188,39,0)',
								},
								{
									offset: 0,
									color: 'rgba(248,188,39,0.7)',
								},
							]),
						}
					}
					option3.series[1].label.color = '#000000'
					option3.series[1].label.fontSize = 12
					option3.series[1].label.fontWeight = 400
					option3.series[2].itemStyle.color = '#DFA20A'
				}
				myChart3.setOption(option3)
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.red {
	.cash {
		margin-top: 14px;
		width: 1040px;
		height: 503px;
		position: relative;
		background: #ffffff;
		box-shadow: 2px 2px 10px 6px rgba(211, 47, 46, 0.07);
    border: 1px solid rgba(211, 47, 46, 0.07);
	}
}

.purple {
	.cash {
		margin-top: 14px;
		width: 1040px;
		height: 503px;
		position: relative;
		background: #ffffff;
		box-shadow: 2px 2px 10px 6px rgba(211, 47, 46, 0.07);
    border: 1px solid rgba(211, 47, 46, 0.07);
	}
}

.cards {
	margin-top: 12px;
	padding: 0 46px;
	display: flex;
	justify-content: space-around;
}

.card {
	width: 300px;
	height: 375px;
	border-radius: 8px;
	border: 1px solid var(--borderColor);
}
.zh .card-title {
	margin-top: 20px;
	margin-left: 19px;
	height: 28px;
	font-size: 18px;
	font-weight: 600;
	color: var(--timeTitleColor);
	line-height: 25px;
}
.zh .card-text {
	color: var(--contentTitleColor);
	font-size: 20px;
}
.zh .num {
	margin-left: 19px;
	height: 50px;
	font-size: 36px;
	font-weight: 600;
	color: var(--numColor);
	line-height: 50px;
}
.unit {
	font-size: 16px;
}
.en .card-title {
	margin-top: 16px;
	margin-left: 20px;
	height: 50px;
	font-size: 18px;
	font-weight: 600;
	color: var(--timeTitleColor);
	line-height: 25px;
}
.en .card-text {
	font-size: 18px;
	color: var(--contentTitleColor);
}
.en .num {
	margin-left: 20px;
	width: 122px;
	height: 50px;
	font-size: 36px;
	font-weight: 600;
	color: var(--numColor);
	line-height: 50px;
}

.charts {
	width: 300px;
	height: 250px;
}
.blue {
	.cash {
		padding: 0 80px;
		padding-top: 27px;
		width: 980px;
		height: 489px;
		position: relative;
	}
	.cards {
		margin-top: 34px;
		display: flex;
		justify-content: center;
	}

	.card {
		width: 300px;
		height: 375px;
		background: #ecf2fd;
		border-radius: 8px;
		border: none;
	}

	.card:nth-child(2) {
		margin-left: 40px;
	}
	.card:nth-child(3) {
		margin-left: 40px;
	}
}
.yellow {
	.cash {
		width: 980px;
		height: 510px;
		padding: 0 80px;
		background: #f5f6f8;
		border-radius: 28px;
		position: relative;
	}
	.cards {
		margin-top: 34px;
		padding: 0;
		display: flex;
		justify-content: center;
	}

	.card {
		width: 300px;
		height: 375px;
		background: #ffffff;
		box-shadow: 6px 2px 9px 0px rgba(165, 165, 165, 0.2);
		border-radius: 8px;
		border: none;
	}
	.card:nth-child(2) {
		margin-left: 40px;
	}
	.card:nth-child(3) {
		margin-left: 40px;
	}
}
</style>
